import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from './../../../../services/alert.service';
import { GlobalFilterService } from './../../../../services/global-filter.service';
import { FavoriteApi } from './../../../../sdk/services/custom/Favorite';
import { MessageService } from '../../../../services/message.service';
import { AppStateService } from '../../../../services/app-state.service';
import { CommentApi } from '../../../../sdk/services/custom/Comment';
import { CommonService } from 'shared/services/common.service';
import { PreloaderService } from '../../../../services/preloader.service';
import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';
import { hiddenGlobalFiltersWo } from 'shared/models/static-list-data.service';
import { MessageSocketService } from 'shared/services/message-socket.service'
import { Subscription } from 'rxjs/internal/Subscription';
import { MessageNotificationSocketService } from 'shared/services/message-notification-socket.service';

@Component({
  selector: 'app-specific-global-chat',
  templateUrl: './specific-global-chat.component.html',
  styleUrls: ['./specific-global-chat.component.css'],
})
export class SpecificGlobalChatComponent implements OnInit, OnDestroy, AfterViewInit {
  type: string;
  filterObj: any = {};
  createdAt = null;
  timerSub: any;
  filterCondition: boolean;
  limit = 100;
  accessType: any;
  listData: any[] = [];
  pinnedData: any[] = [];
  activeId: any;
  errorMessage: string;
  isLoadMore: boolean;
  defaultToggleView = true; // default 5 line
  refreshFavList: boolean;
  selectedItem: any;
  selectedWorkorder: {};
  visibleMenuOptions = ['work-order', 'job-status', 'filter'];
  currentMenuOption = 'work-order';
  sidebarMenuOpened = false;
  PINNED_MESSAGE_ID: string;
  teamFilter: any;
  selectedIndex: number;
  activeTab = 'caseMessageTab';
  enableFilters = [
    'dateOptions',
    'accounts',
    'customers',
    'programs',
    'jobSites',
    'regions',
    'caseTypes',
    'statgeStatus',
    'priority',
    'pmsCaseStatus',
    'pmsCaseNumbers',
    'pmcCaseNumbers'
  ]
  autoSelected = true;
  currentTab: string;
  pendingNotificationSelection: any = null;
  awaitingPendingSelection = false;
  private initialListLoaded = false;
  private messageSubscription: Subscription;
  private messageNotificationSocketSubscription: Subscription;
  private pendingSelectionSubscription: Subscription;

  private _gotNewMessagesFromSocket = false;
  private _ticker;
  selectedChatMessagingConsoleType:string='soMessage';

  constructor(
    private _loader: PreloaderService,
    private _commonService: CommonService,
    private _commentApi: CommentApi,
    private _appState: AppStateService,
    private _messageService: MessageService,
    private _favoriteApi: FavoriteApi,
    private _globalFilters: GlobalFilterService,
    private _alertService: AlertService,
    private activateRoute: ActivatedRoute,
    private messageSocketService: MessageSocketService,
    private _messageNotificationSocketService: MessageNotificationSocketService,
    private _router: Router
  ) {}

  initInterval() {
    let that = this;
    if(!this._ticker){
      this._ticker = setInterval(function () {
        // your code below
        if(that._gotNewMessagesFromSocket){
          that.loadListData();
          that._gotNewMessagesFromSocket = false;
        }
      }, 120000);
    }
  }

  ngOnInit() {
    this.initInterval();
    this.accessType = this._appState.getAccessType();
    this.activateRoute.params.subscribe(params => {
      this.defaultToggleView = true;
      // this._messageService.setMsgViewType(this.defaultToggleView);
      this.teamFilter = params['name'].split('?')[0] || '';
      //console.log("this.teamFilter",this.teamFilter)
      this._messageNotificationSocketService.registerConsole(this.getSelectedConsoleType(this.teamFilter));

      this.currentMenuOption = 'work-order';

      switch (this.teamFilter) {
        case 'pmc':
          this.PINNED_MESSAGE_ID = 'PINNED_PMC_MESSAGE_ID';
          this._commonService.saveCurrentPageAnalytics('Global Chat - Program Console', 'Program (PMC) Console')
          break;
        case 'billing':
          this.PINNED_MESSAGE_ID = 'PINNED_BILLING_MESSAGE_ID';
          this.enableFilters = ['dateOptions', 'accounts', 'customers', 'vendorAccounts', 'programs', 'jobSites', 'statgeStatus', 'talentTypes', 'jobs', 'jobStatus', 'jobTypes', 'vendorSites', 'caseCategory', 'priority', 'geoMetro', 'workerNames', 'pmsCaseStatus', 'pmsCaseNumbers',
            'salesOrder','countries'
          ];
          break;
        case 'purchase-order':
          this.PINNED_MESSAGE_ID = 'PINNED_PO_MESSAGE_ID';
          this.enableFilters = ['dateOptions', 'vendorAccounts', 'purchaseOrder', 'jobSites', 'jobs', 'jobStatus', 'jobTypes', 'vendorSites', 'priority', 'geoMetro', 'workerNames'];
          this.visibleMenuOptions = ['job-status', 'filter'];
          this.currentMenuOption = 'job-status';
          this._commonService.saveCurrentPageAnalytics('PO Messaging');
          break;
        default:
          this.PINNED_MESSAGE_ID = 'PINNED_ICC_MESSAGE_ID';
          this._commonService.saveCurrentPageAnalytics('Global Chat - Billing (SO/PO) Console', 'Billing (SO/PO) Console')
          break;
      }
      // to load already selected filters from storage
      this.filterCondition = this._commonService.getGlobalFilter(this.enableFilters);
      if (this.filterCondition['Customer__c']) {
        if (this.filterCondition['CKSW_BASE__Account__c']) {
          this.filterCondition['CKSW_BASE__Account__c']['inq'] = this.filterCondition['CKSW_BASE__Account__c']['inq'].concat(this.filterCondition['Customer__c']['inq']);
        } else {
          this.filterCondition['CKSW_BASE__Account__c'] = this.filterCondition['Customer__c'];
        }
        delete this.filterCondition['Customer__c'];
      }
      this.loadListData();
      this.getRealtimeMessage();
    });
    
    this.getJobMessageConsoleSocketEvents();
    // Reacts to a notification click while this page is already mounted (switch tab / select
    // thread without a route reload). getPendingSelection() is a BehaviorSubject, so it also
    // replays the current value synchronously here on fresh navigation - at that point
    // initialListLoaded is still false (loadListData() above hasn't returned yet), so this defers
    // to subscribeJob()'s success handler instead of searching an empty listData and giving up.
    this.pendingSelectionSubscription = this._messageNotificationSocketService.getPendingSelection().subscribe(row => {
      if (!row) {
        return;
      }
      this.pendingNotificationSelection = row;
      //console.log('pendingSelection', this.pendingNotificationSelection);
      this.awaitingPendingSelection = true;
      if (this.pendingNotificationSelection) {
        this.applyPendingNotificationSelection();
      }
    });

     // If a notification click sent us here targeting a specific tab, start on that tab so the
      // first load already fetches the right (PO vs SO) data set instead of loading the default
      // tab and immediately reloading.
      const pendingSelection = this._messageNotificationSocketService.peekPendingSelection();
      if (this.teamFilter === 'billing' && pendingSelection && pendingSelection.targetTab) {
        //console.log('pendingSelection', pendingSelection);
        this.activeTab = pendingSelection.targetTab;
        this.pendingNotificationSelection = pendingSelection;
        this.awaitingPendingSelection = true;
      }
  }
  ngAfterViewInit(){
    // this._messageNotificationSocketService.joinNotificationSocketRoom('JOB-BILLING-PO-285530');
    
  }

  loadListData() {
    // if (this.type === 'favourite') {
    //   this.filterObj['listType'] = 'FavJob';
    // }
    this.createdAt = '';
    this.unsubscribeTimer();
    delete this.filterObj['createdAt'];
    this._loader.showPreloader();
    this.subscribeJob(0, false);
    /*
    this.timerSub = Observable.timer(0, 30000).subscribe(() => {
      this.subscribeJob(0, false);
    });
    */
  }

  /**load Job message console list data */
  subscribeJob(skip, loadMore) {
    if (this.createdAt && !loadMore) {
      this.filterObj['createdAt'] = { gte: this.createdAt };
      // this._messageService.setCountCall(true);
    } else {
      this._loader.showPreloader();
    }
    if(this.teamFilter === 'escalations'){
      delete this.filterObj['modelName'];
      delete this.filterObj['commentType'];
      this.filterObj['listType'] = 'Escalation';

    }else{
      delete this.filterObj['listType'];
      this.filterObj['modelName'] = 'Job';

    }

    if (
      this.filterCondition &&
      this.filterCondition['Iron_Case_Number__c'] !== undefined
    ) {
      this.filterObj['Iron_Case_Number__c'] = this.filterCondition[
        'Iron_Case_Number__c'
      ];
    } else {
      delete this.filterObj['Iron_Case_Number__c'];
    }

    if (this.teamFilter && ['pmc', 'billing', 'icc', 'purchase-order'].includes(this.teamFilter)) {
      this.filterObj['commentType'] = this.teamFilter == 'purchase-order' ? 'billing' : this.teamFilter;
    }
    const filters = {
      where: this.filterObj,
      limit: this.limit,
      skip: skip,
      enablePurchaseOrderChat: this.teamFilter === 'purchase-order' || (this.accessType === 'internal' && this.activeTab === 'poMessageTab'),
      enableSalesOrderChat: (this.accessType === 'internal' && this.activeTab ==='caseMessageTab' && this.teamFilter==='billing'),
      enableWorkOrderChat: !['billing', 'purchase-order'].includes(this.teamFilter),
      enableChatRoom: true
    };
    if (this.filterCondition && Object.keys(this.filterCondition).length) {
      delete this.filterCondition['Iron_Case_Number__c'];
      const preFilterObj = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : {};
      if (this.filterCondition['Jobsite__c'] && this.filterCondition['Jobsite__c']['inq'] &&
        preFilterObj['geoMetroJobSite'] && preFilterObj['geoMetroJobSite'].length && !this.enableFilters.includes('geoMetro')) {
        let jobSite = this.filterCondition['Jobsite__c']['inq'].filter(Boolean).filter(element => !preFilterObj['geoMetroJobSite'].includes(element));
        const localFilterCondition = this.filterCondition;
        if (jobSite && jobSite.length) {
          localFilterCondition['Jobsite__c']['inq'] = jobSite;
        } else {
          delete localFilterCondition['Jobsite__c'];
        }
        filters['jobFilter'] = localFilterCondition;
      } else {
        filters['jobFilter'] = this.filterCondition;
      }
    }
    // if (this.type === 'favourite') {
    //   delete filters['jobFilter'];
    // }

    this._commentApi.getDistinctByType(filters).subscribe(
      (_data) => {
        if (this.filterObj['createdAt']) {
          this.unshiftDataInList(_data);
        } else {
          this.listData = [..._data];
          this.initialListLoaded = true;

          if (this.awaitingPendingSelection && this.applyPendingNotificationSelection()) {
            // handled above - either the thread was selected, or a tab switch it triggered will
            // retry the selection once that tab's list lands
          } else if (this.autoSelected) {
            this.selectFirstRecord();
          } else if(!this.autoSelected) {
            // get new index selected active id
            try {
              const index = this.listData.findIndex(item => item._id === this.activeId);
              this.selectedIndex = index; //selectedIndex
            } catch (error) {
              console.log('Error while getting index of current selected element in list ', error)
            }
          }

          if (
            this.filterCondition &&
            Object.keys(this.filterCondition).length === 1 &&
            this.filterCondition['Iron_Job_num__c']
          ) {
            this.isLoadMore = false;
          } else {
            // this.isLoadMore = _data.length < this.limit ? false : true;
            this.isLoadMore = _data.length > 0 ? true : false;
          }
          // if (this.type === 'all') {
          this.removePinnedRecords();
          // }
        }
        this.createdAt = new Date();
        //console.log("====this.listData===", this.listData);
        
        this._loader.hidePreloader();
      },
      (err) => {
        this._loader.hidePreloader();
      }
    );
    if(this.accessType === 'internal' && this.activeTab ==='caseMessageTab' && this.teamFilter==='billing'){
      this._messageService.setSelectedTabType('soMessage')
    }else if(this.accessType === 'internal' && this.activeTab ==='poMessageTab' && this.teamFilter==='billing'){
      this._messageService.setSelectedTabType('poMessage')
    }
  }

  unshiftDataInList(_data, isLoadMore?) {
    _data.forEach((_newItem) => {
      let index;
      if (
        !this.listData.some((item, i) => {
          index = i;
          return item.modelId === _newItem.modelId;
        })
      ) {
        let jobFoundInPinned = false;
        this.pinnedData.forEach((pinnedItem) => {
          if (
            pinnedItem.modelId === _newItem.modelId &&
            pinnedItem.modelName === _newItem.modelName
          ) {
            pinnedItem['last_postByName'] = _newItem['last_postByName'];
            pinnedItem['last_createdAt'] = _newItem['last_createdAt'];
            pinnedItem['last_message'] = _newItem['last_message'];
            pinnedItem['count'] += _newItem['count'];
            pinnedItem['unread_comments'] += _newItem['unread_comments'];
            jobFoundInPinned = true;
            this._messageService.setNewMessageJob(_newItem);
          }
        });
        if (!jobFoundInPinned) {
          if (isLoadMore) {
            this.listData.push(_newItem);
          } else {
            this.listData.unshift(_newItem);
          }
        }
      } else {
        this.listData[index]['last_postByName'] = _newItem['last_postByName'];
        this.listData[index]['last_createdAt'] = _newItem['last_createdAt'];
        this.listData[index]['last_message'] = _newItem['last_message'];
        this.listData[index]['count'] += _newItem['count'];
        this.listData[index]['unread_comments'] += _newItem['unread_comments'];
        this._messageService.setNewMessageJob(_newItem);
      }
    });
  }

  /**
   * select first item of list
   */
  selectFirstRecord() {
    if (this.listData.length) {
      this.activeId = this.listData[0]._id;
      this.selectedIndex = 0; //selectedIndex
      this.listData[0].unread_comments = 0;

      this.listData[0]['teamFilter'] = this.teamFilter ? this.teamFilter : null;
      this.onClick(null, this.listData[0], 'list');
    } else {
      this.selectedItem = {};
      this.selectedWorkorder = {};
      this.errorMessage = 'No message found';
    }
  }

  /**
   * Change list view
   */
  toggleListView() {
    this.defaultToggleView = !this.defaultToggleView;
    // this._messageService.setMsgViewType(this.defaultToggleView);
  }

  /**
   *
   * @param e load more data
   */
  onloadMoreChange(e) {
    this._loader.showPreloader();
    delete this.filterObj['createdAt'];
    this.filterObj['modelName'] = 'Job';
    if (
      this.filterCondition &&
      this.filterCondition['Iron_Case_Number__c'] !== undefined
    ) {
      this.filterObj['Iron_Case_Number__c'] = this.filterCondition[
        'Iron_Case_Number__c'
      ];
    } else {
      delete this.filterObj['Iron_Case_Number__c'];
    }
    const filters = {
      where: this.filterObj,
      limit: this.limit,
      skip: this.listData.length,
      enablePurchaseOrderChat: this.teamFilter == 'purchase-order',
      enableWorkOrderChat: !['billing', 'purchase-order'].includes(this.teamFilter),
      enableChatRoom: true
    };
    if (this.filterCondition && Object.keys(this.filterCondition).length) {
      delete this.filterCondition['Iron_Case_Number__c'];
      filters['jobFilter'] = this.filterCondition;
    }
    // if (this.type === 'favourite') {
    //   delete filters['jobFilter'];
    // }
    this._commentApi.getDistinctByType(filters).subscribe(
      (_data) => {
        this.unshiftDataInList(_data, true);
        this._loader.hidePreloader();
      },
      (err) => {
        this._loader.hidePreloader();
      }
    );
  }

  /**
   *
   * @param e update fav object
   */
  handleFavChange(e) {
    if (e.favoriteId) {
      this.deleteFavorite(e);
    } else {
      this.addFavorite(e);
    }
  }

  addFavorite(item) {
    this._loader.showPreloader();
    this._favoriteApi
      .upsert({
        modelId: item.modelId,
        modelName: item.modelName,
      })
      .subscribe(
        (result) => {
          this._loader.hidePreloader();
          if (result && result['id']) {
            item.favoriteId = result['id'];
          }
          // this.getCount(['FaviorateAll', 'FaviorateJob']);
        },
        (err) => {
          this._loader.hidePreloader();
        }
      );
  }

  deleteFavorite(item) {
    this._loader.showPreloader();
    this.refreshFavList = false;
    this._favoriteApi.deleteById(item.favoriteId).subscribe(
      (result) => {
        this._loader.hidePreloader();
        if (result && result['count']) {
          item.favoriteId = '';
          this.refreshFavList = true;
        }
        // this.getCount(['FaviorateAll', 'FaviorateJob']);
      },
      (err) => {
        this._loader.hidePreloader();
      }
    );
  }

  onClick(event, item, button) {
    if (button === 'fav') {
      this.handleFavChange(event);
    } else {
      this.activeId = item._id;
      item.unread_comments = 0;
      this.selectedWorkorder = {};
      this.selectedIndex = this.getIndexOfSelected(this.activeId);
      // this.showFilter = false;
      // this.showWorkOrder = (this.accessType === 'internal') ? true : false; // default workorder case of internal
      // this.showJobDetail = (this.accessType === 'internal') ? false : true;
      if((this.teamFilter == 'purchase-order' && this.accessType === 'vendor') || (this.teamFilter == 'purchase-order' && this.accessType === 'internal')) {
        this.setchatRoomId(item);
        if (item.job) {
         item.job['selectChatRoomId'] = 9; // It's For Purchase Order
        }        
      }

      if (item.job && item.job.Work_Order_Number) {
        item['workOrder'] = { sfdcId: item.job.Work_Order_Number };
      }
      item['teamFilter'] = this.teamFilter ? this.teamFilter : null;
      this.selectedItem = item;
      if (item.workOrder && item.workOrder.sfdcId) {
        this.selectedWorkorder = { modelId: item.workOrder.sfdcId, modelName: 'WorkOrder' };
      }      
      }
  }

    /**
   *  Enabled Private (3PS/PO/PI/PP) tab number 9 only
   */
  setchatRoomId(item) {

    console.log("setchatRoomId",item)
    this._messageService.setchatRoomId({
      count: 0,
      id: (item.caseModelId) ? item.caseModelId.toString() : "",
      idx: 9,
      isPublic: false,
      label1: 'Private',
      label2: '(3PS/PO/PI/PP)',
      sfdcId: item.Case__c,
      value:item.job.purchaseOrder ? item.job.purchaseOrder.Work_Order_num__c  : ''
    }
   )
  }

  /**
   * Applies a notification click's target thread/tab (see pendingNotificationSelection) against
   * the currently loaded listData. Returns true if it either selected the thread or kicked off a
   * tab switch that will retry the selection once that tab's own list lands - both cases mean the
   * caller (subscribeJob()'s success handler) should skip its own default first-record selection.
   *
   * Once the target tab is actually reached, this resolves in one shot - selects the thread if
   * found, then clears the pending selection either way. It must not stay "pending" on a miss:
   * left set, it would keep firing on every later, unrelated reload (e.g. a manual tab click) and
   * force the view back to this stale target tab instead of respecting the user's own action.
   */
  applyPendingNotificationSelection(): boolean {
    const pending = this.pendingNotificationSelection;
    console.log("applyPendingNotificationSelection",pending)
    if (!pending || !this.teamFilter) {
      this.clearPendingNotificationSelection();
      return false;
    }
    if (this.teamFilter === 'billing' && pending.targetTab && this.activeTab !== pending.targetTab) {
      this.onTabChange({ nextId: pending.targetTab });
      // Stays pending - onTabChange() reloads that tab's list, and subscribeJob()'s success
      // handler will call this again once it lands, this time with activeTab === targetTab.
      return true;
    }
    if (this.teamFilter !== 'billing' && this.teamFilter !== 'purchase-order') {
      this.clearPendingNotificationSelection();
      return false;
    }
    const item = this.listData.find(i => i.caseModelId === pending.modelId);
    //console.log('applyPendingNotificationSelection', item, pending, this.listData);
    if (item) {
      this.onClick(null, item, 'list');
    }
    this.clearPendingNotificationSelection();
    return !!item;
  }

  private clearPendingNotificationSelection() {
    this.pendingNotificationSelection = null;
    this.awaitingPendingSelection = false;
    this._messageNotificationSocketService.clearPendingSelection();
  }

  onTabChange(tab) {
    this.activeTab = tab.nextId;
    if (tab.nextId === 'caseMessageTab' || tab.nextId === 'poMessageTab') {
      this._messageNotificationSocketService.registerConsole(this.getSelectedConsoleType(tab.nextId));
    }
    if(this.accessType === 'internal' && this.activeTab ==='caseMessageTab' && this.teamFilter==='billing'){
      this._messageService.setSelectedTabType('soMessage');
      const filterIndex = this.enableFilters.findIndex(filter => filter == 'purchaseOrder');
      if(this.enableFilters[filterIndex]){
        this.enableFilters.splice(filterIndex, 1);
      }      
      this.enableFilters.push('salesOrder')
    }else if(this.accessType === 'internal' && this.activeTab ==='poMessageTab' && this.teamFilter==='billing'){
      this._messageService.setSelectedTabType('poMessage');
      const filterIndex = this.enableFilters.findIndex(filter => filter == 'salesOrder');
      if(this.enableFilters[filterIndex]){
        this.enableFilters.splice(filterIndex, 1);
      }
      this.enableFilters.push('purchaseOrder')
    }
    const filterIndex = this.enableFilters.findIndex(filter => filter == 'regions');
    this.currentMenuOption = 'work-order';
    if (tab.nextId === 'workOrderTab') {
      this.unsubscribeTimer();
      this.currentTab = 'workOrderTab';
      this.selectedItem = {};
      this.selectedWorkorder = {};
      if(this.enableFilters[filterIndex])
        this.enableFilters.splice(filterIndex, 1);
    } else {
      if (!this.enableFilters[filterIndex])
        this.enableFilters.push('regions');
      this.currentTab = 'caseMessageTab';
      this.loadListData();
    }
  }

  isRightMenuOpened(isOpened) {
    this.sidebarMenuOpened = isOpened;
    this._globalFilters.setSidebarState(isOpened);
  }

  searchCaseMessages(filterObj) {
    this.filterCondition = filterObj;
    if (this.filterCondition['Customer__c']) {
      if (this.filterCondition['CKSW_BASE__Account__c']) {
        this.filterCondition['CKSW_BASE__Account__c']['inq'] = this.filterCondition['CKSW_BASE__Account__c']['inq'].concat(this.filterCondition['Customer__c']['inq']);
      } else {
        this.filterCondition['CKSW_BASE__Account__c'] = this.filterCondition['Customer__c'];
      }
      delete this.filterCondition['Customer__c'];
    }
    if (this.currentTab !== 'workOrderTab') {
      this.loadListData();
    }
  }

  /**
  * Pin or unpin action has been performed
  */
  onPinAction(jobData) {
    // if (this.type !== 'all') {
    //   return;
    // }
    const pinnedLocalData = localStorage.getItem(this.PINNED_MESSAGE_ID) ? JSON.parse(localStorage.getItem(this.PINNED_MESSAGE_ID)) : [];
    let alreadyPinnedData = false;
    pinnedLocalData.forEach((item, index) => {
      if (jobData && (item.id === jobData.modelId && item.modelName === jobData.modelName)) {
        pinnedLocalData.splice(index, 1);
        this.pinnedData.splice(this.pinnedData.indexOf(jobData), 1);
        localStorage.setItem(this.PINNED_MESSAGE_ID, JSON.stringify(pinnedLocalData));
        alreadyPinnedData = true;
      }
    })
    if (alreadyPinnedData) {
      if (Object.keys(this.filterCondition).length) {
        delete this.filterObj['createdAt'];
        this.createdAt = null;
        this.subscribeJob(0, false);
      } else {
        this.listData.push(jobData);
        this.sortListData();
      }
      return;
    }
    if (pinnedLocalData && pinnedLocalData.length === 2) {
      return this._alertService.error('You can not pin more than two items.');
    }

    const data = {
      id: jobData.modelId,
      modelName: jobData.modelName
    }

    if (jobData.job) {
      data['Case__c'] = jobData.job.Case__c;
      data['PMC_Case_Number'] = jobData.job.PMC_Case_Number;
    } else if (jobData.workOrder) {
      data['Case__c'] = jobData.Case__c;
      data['PMC_Case_Number'] = jobData.workOrder.JPC_Case__c;
    }
    pinnedLocalData.push(data)
    localStorage.setItem(this.PINNED_MESSAGE_ID, JSON.stringify(pinnedLocalData));
    const pinnedData = this.listData.splice(this.listData.findIndex(item =>
      (item.modelId === jobData.modelId && item.modelName === jobData.modelName)), 1);
    if (pinnedData && pinnedData.length) {
      this.pinnedData.unshift(pinnedData[0]);
    }
  }

  /**
   * Get the data of pinned jobs
   */
  getPinnedJobs() {
    const localStoragePinnedData = JSON.parse(localStorage.getItem(this.PINNED_MESSAGE_ID));
    const case_c = [];
    localStoragePinnedData.forEach(item => {
      case_c.push(item.Case__c);
      if (item.PMC_Case_Number) {
        case_c.push(item.PMC_Case_Number);
      }
    })
    const filters = {
      where: {
        'Case__c': { '$in': case_c }
      },
      limit: this.limit,
      skip: 0,
      enablePurchaseOrderChat: this.teamFilter == 'purchase-order' || (this.accessType === 'internal' && this.activeTab === 'poMessageTab'),
      enableSalesOrderChat: (this.accessType === 'internal' && this.activeTab ==='caseMessageTab'),
      enableWorkOrderChat: !['billing', 'purchase-order'].includes(this.teamFilter),
      enableChatRoom: true
    };
    this._commentApi.getDistinctByType(filters).subscribe(_data => {
      this.pinnedData = _data;
    }, err => {
      console.log(err);
    })
  }

  /**
  * Remove all the pinned messages from current message list and push them in pinned data list
  */
  removePinnedRecords() {
    this.pinnedData = [];
    if (localStorage.getItem(this.PINNED_MESSAGE_ID)) {
      const localStoragePinnedData = JSON.parse(localStorage.getItem(this.PINNED_MESSAGE_ID));
      localStoragePinnedData.forEach(item => {
        this.listData.forEach((data, index) => {
          if (data && (data.modelId === item.id && data.modelName === item.modelName)) {
            const pinnedData = this.listData.splice(index, 1);
            if (pinnedData && pinnedData.length) {
              this.pinnedData.unshift(pinnedData[0]);
            }
          }
        })
      })
      if (this.pinnedData.length !== localStoragePinnedData.length) {
        this.getPinnedJobs();
      }
    }
  }

  sortListData() {
    this.listData.sort((a, b) => {
      const bDateTime = new Date(Date.parse(b.last_createdAt));
      const aDateTime = new Date(Date.parse(a.last_createdAt));
      return bDateTime.getTime() - aDateTime.getTime();
    })
  }

  unsubscribeTimer() {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }

  getRealtimeMessage() {
    // console.log('Fetching the message from socket.');
    let that = this;
    this.messageSubscription = this._messageService.getNewMessageJob().subscribe(result => {
      // const date = new Date(result.payload.createdAt)
      // date.setSeconds(date.getSeconds() - 1)
      // this.createdAt = date.toISOString(); // add message created date 
      // this.subscribeJob(0, false);
      result = result[0];
      console.log('++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++');
      this._commonService.logger('RESULT HHHHHHHHHHHHH', result);
      this.selectedIndex = this.getIndexOfSelected(this.activeId);
      const filterMatched = this.checkifDataFilterMatch(result);
      let MessageIndex = this.checkIfCardExists(result);

      if(MessageIndex != null && filterMatched) {
        this.updateListData(MessageIndex, result);
        this.sortListData();
      } else if(MessageIndex == null && filterMatched) {
        this.autoSelected = false;
        // this.loadListData();
        that._gotNewMessagesFromSocket = true;
        this._commonService.logger('INDEX NOT FOUND BUT FILTER MATCHED.');
      }

    })
  }

  /**
   * Subscribes to the shared job-message-console socket client (initialized once from
   * app-nav-header). Payload field names (message/sender/timestamp/...) are placeholders until
   * the backend contract for environment.messageNotificationSocketUrl is confirmed.
   */
  getJobMessageConsoleSocketEvents() {
    this._messageNotificationSocketService.registerConsole(this.selectedChatMessagingConsoleType);
    if (!this.messageNotificationSocketSubscription) {
      this.messageNotificationSocketSubscription = this._messageNotificationSocketService.getMessage(this.filterObj['commentType']).subscribe(result => {
         if(Object.keys(result) && Object.keys(result).length && result.subModelName == this.selectedChatMessagingConsoleType) {
          this.handleJobMessageConsoleSocketEvent(result);
          console.log('Message received in ====', this.selectedChatMessagingConsoleType);       
        }
      });
    }
  }

  /**
   * Places the card for an incoming socket message at the front of listData - updating it in
   * place (reusing updateListData(), same as getRealtimeMessage()) and moving just that card to
   * index 0 if it already exists, or prepending a new card if it doesn't. Unlike
   * getRealtimeMessage()'s sortListData(), every other card keeps its existing position.
   */
  handleJobMessageConsoleSocketEvent(result) {
    this.selectedIndex = this.getIndexOfSelected(this.activeId);
    const cardIndex = this.checkIfCardExists(result);
    console.log("handleJobMessageConsoleSocketEvent")

    if (cardIndex !== null) {
      this.updateListData(cardIndex, {
        Case_Comment_Body__c: result.Case_Comment_Body__c,
        postByName: result.contact && result.contact.users && result.contact.users.firstname,
        createdAt: result.CreatedDate,
        workOrder:result.workOrder,
        job:result.job


      });
      if (cardIndex > 0) {
        const [movedCard] = this.listData.splice(cardIndex, 1);
        this.listData.unshift(movedCard);
      }
    } else {
      this.listData.unshift(this.buildListItemFromSocketMessage(result));
    }
  }

  /**
   * Best-effort card for a job/case that doesn't yet have an entry in listData - only the
   * fields the socket payload actually carries are known until the backend contract is
   * confirmed (see getJobMessageConsoleSocketEvents()); everything else defaults so downstream
   * template bindings (last_message, unread_comments, ...) don't break.
   */
  buildListItemFromSocketMessage(result): any {
    return {
      ...result,
      _id: result._id || `${result.modelName}-${result.modelId}`,
      last_message: result.Case_Comment_Body__c || '',
      last_postByName: (result.contact && result.contact.users && result.contact.users.firstname) || '',
      last_createdAt: result.CreatedDate || new Date().toISOString(),
      count: 1,
      unread_comments: 1
    };
  }

  /**
   * Same soMessage/poMessage classification already used by setSelectedTabType() in
   * subscribeJob()/onTabChange() - kept in sync so the socket room matches the visible tab.
   */
  getSelectedConsoleType(tabId: string): string {
    // if (this.teamFilter === 'purchase-order') {
    //   return 'poMessage';
    // }
    // if (this.accessType === 'internal' && this.teamFilter === 'billing' && (this.activeTab === 'poMessageTab' || this.activeTab === 'caseMessageTab')) {
    //   return 'poMessage';
    // }
    let msgType = ''
    if(this.accessType === 'internal' && this.teamFilter === 'billing' && (tabId === 'caseMessageTab')) {
      msgType = 'soMessage';
    }else if((tabId === 'poMessageTab' || tabId === 'purchase-order')) {
      msgType = 'poMessage';
    }
    return this.selectedChatMessagingConsoleType = msgType;
  }

  // check if list has the card for incoming message.
  checkIfCardExists(incomingMessage) {
    let indexOfCard = null;
    this.listData.filter(function (e, i) {
      if(typeof e.context !== 'undefined' && e.context !== null && incomingMessage.context) {
        if (typeof incomingMessage.context.jobId !== 'undefined' && typeof e.context.jobId !== 'undefined' && incomingMessage.context.jobId !== null && e.context.jobId === incomingMessage.context.jobId) {
          indexOfCard = i;
        } else if (
          typeof e.context.workOrderId !== 'undefined' &&
          typeof incomingMessage.context.workOrderId !== 'undefined' &&
          e.context.workOrderId === incomingMessage.context.workOrderId) {
          indexOfCard = i;
        }
      }
      if (e.modelName == incomingMessage.modelName && e.modelId == incomingMessage.modelId) {
        indexOfCard = i;
      } else if (e.caseModelId && e.caseModelId == incomingMessage.modelId) {
        // PO/billing list rows are re-keyed to the Job's Mongo _id with modelName 'Job'
        // (see comment.js prepareIccCaseCommentData), but the socket notification still carries
        // the original Case-based modelName/modelId - match on the stashed caseModelId instead.
        indexOfCard = i;
      }
    });
    return indexOfCard;
  }
  getIndexOfSelected(id) {
    let index = null;
    this.listData.filter(function (e, i) {
      if(e._id === id){
        index = i;
      }
    });
    return index;
  }
  updateListData(index, data) {
    this.listData[index]['last_message'] = data.Case_Comment_Body__c;
    this.listData[index]['last_postByName'] = data.postByName;
    this.listData[index]['last_postByName'] = data.postByName;
    this.listData[index]['count'] = this.listData[index]['count'] + 1;
    // console.log("Active card ID, ", this.selectedIndex, ' :: INDEX :: ', index);
    if(this.selectedIndex !== index) {
      this.listData[index]['unread_comments'] = this.listData[index]['unread_comments'] + 1;
    }
    this.listData[index]['last_createdAt'] = data.createdAt;
  }
  checkifDataFilterMatch(data) {
    let filterMatched = true;
    const messageFilter = data.filters;
    console.log(this.filterObj);
    if (Object.keys(this.filterObj).length) {
      // CreatedAt Filter
      if (typeof this.filterObj.CreatedDate !== 'undefined') {
        filterMatched = this.checkDateInRange(this.filterObj.CreatedDate.between, data.createdAt)
      }
      // Partner Account filter
      if (typeof this.filterObj.CKSW_BASE__Account__c !== 'undefined') {
        filterMatched = this.filterObj.CKSW_BASE__Account__c.inq.includes(messageFilter.partnerAccount);
      }
      // Program filter 
      if (typeof this.filterObj.Project_SOP__c !== 'undefined') {
        filterMatched = this.filterObj.Project_SOP__c.inq.includes(messageFilter.projectId);
      }
      // Jobsite Location filter 
      if (typeof this.filterObj.Jobsite__c !== 'undefined') {
        filterMatched = this.filterObj.Jobsite__c.inq.includes(data.jobSiteId);
      }
      // Priority 
      if (typeof this.filterObj.Service_Dispatch_SLA_Priority__c !== 'undefined') {
        filterMatched = this.filterObj.Service_Dispatch_SLA_Priority__c.inq.includes(messageFilter.Service_Dispatch_SLA_Priority__c);
      }
      // PMS Case status
      if (typeof this.filterObj.PMS_Case_Status !== 'undefined') {
        filterMatched = this.filterObj.PMS_Case_Status.inq.includes(messageFilter.PMSCaseStatus);
      }
      // PMS Case number
      if (typeof this.filterObj.PMS_Case_Number !== 'undefined') {
        filterMatched = this.filterObj.PMS_Case_Number.inq.includes(messageFilter.PMS_Case_Number);
      }
      // PMC Case number
      if (typeof this.filterObj.PMC_Case_Number !== 'undefined') {
        filterMatched = this.filterObj.PMC_Case_Number.inq.includes(messageFilter.PMS_Case_Number);
      }
      // JOB filters

      // Vendor filter
      if (typeof this.filterObj.Vendor__c !== 'undefined') {
        filterMatched = this.filterObj.Vendor__c.inq.includes(messageFilter.Vendor__c);
      }
      // Stage status
      if (typeof this.filterObj.Dispatch_Service_Resolution_Status__c !== 'undefined') {
        filterMatched = this.filterObj.Dispatch_Service_Resolution_Status__c.inq.includes(messageFilter.Dispatch_Service_Resolution_Status__c);
      }
      //region filter
      if (typeof this.filterObj.Region !== 'undefined') {
        filterMatched = this.filterObj.Region.inq.includes(messageFilter.Region);
      }
      // Talent_type
      if (typeof this.filterObj.Talent_Type__c !== 'undefined') {
        filterMatched = this.filterObj.Talent_Type__c.inq.includes(messageFilter.Talent_Type__c);
      }
      // JOB number
      if (typeof this.filterObj.Iron_Job_num__c !== 'undefined') {
        filterMatched = this.filterObj.Iron_Job_num__c.inq.includes(messageFilter.Iron_Job_num__c);
      }
      // job status
      if (typeof this.filterObj.Job_Status_Internal__c !== 'undefined') {
        filterMatched = this.filterObj.Job_Status_Internal__c.inq.includes(messageFilter.Job_Status_Internal__c);
      }
      // Vendor site
      if (typeof this.filterObj.Vendorsite__c !== 'undefined') {
        filterMatched = this.filterObj.Vendorsite__c.inq.includes(messageFilter.Vendorsite__c);
      }
      // Priority JOB
      if (typeof this.filterObj.Service_Dispatch_SLA_Priority__c !== 'undefined') {
        filterMatched = this.filterObj.Service_Dispatch_SLA_Priority__c.inq.includes(messageFilter.Service_Dispatch_SLA_Priority__c);
      }
      // Geo metro
      if (typeof this.filterObj.Jobsite__c !== 'undefined') {
        filterMatched = this.filterObj.Jobsite__c.inq.includes(messageFilter.Jobsite__c);
      }
      // Worker 
      if (typeof this.filterObj.Dispatch_Worker_Name__c !== 'undefined') {
        filterMatched = this.filterObj.Dispatch_Worker_Name__c.inq.includes(messageFilter.Dispatch_Worker_Name__c);
      }
      // pmc window
      if (typeof this.filterObj.commentType !== 'undefined' && this.filterObj.commentType === 'pmc') {
        filterMatched = data.commentType === 'pmc' ? true : false;
      }
      // billing window
      if (typeof this.filterObj.commentType !== 'undefined' && ['billing', 'purchase-order'].includes(this.teamFilter)) {
        filterMatched = ['billing', 'purchase-order'].includes(this.teamFilter) ? true : false;
      }

    }
    console.log('Has filter matched ', filterMatched);
    return filterMatched;
  }

  checkDateInRange(range, date) {
    const minDate = new Date(range[0]);
    const maxDate = new Date(range[1]);
    date = new Date(date);
    if (date > minDate && date < maxDate) {
      return true;
    }
    return true;
  }

  ngOnDestroy() {
    if(this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
    if (this.messageNotificationSocketSubscription) {
      this.messageNotificationSocketSubscription.unsubscribe();
    }
    if (this.pendingSelectionSubscription) {
      this.pendingSelectionSubscription.unsubscribe();
    }
    if(this._ticker) {
      clearInterval(this._ticker);
    }
  }

}
